import React, { useEffect, useState } from "react";
import * as bootstrap from "bootstrap";
import "../App.css";

import campista from "../assets/campista.jpeg";
import lider from "../assets/lider.jpeg";
import voluntario from "../assets/voluntario.jpeg";

import { FaWhatsapp } from "react-icons/fa";

import { FormCampista } from "./forms/FormCampista";
import { FormLider } from "./forms/FormLider";
import { FormVoluntario } from "./forms/FormVoluntario";
import { ModalPago } from "./ModalPago";
import { ModalConfirmacionPago } from "./ModalConfirmacionPago";
import Swal from "sweetalert2";

export const ModalRegistro = ({ show, onClose }) => {
  const [tipo, setTipo] = useState("");

  const [loading, setLoading] = useState(false);

  const [mensajeError, setMensajeError] = useState("");

  // ==========================
  // MODAL PAGO
  // ==========================

  const [mostrarPago, setMostrarPago] = useState(false);

  const [mostrarConfirmacion, setMostrarConfirmacion] = useState(false);

  const [datosPago, setDatosPago] = useState({
    nombre: "",
    documento: "",
  });

  const GOOGLE_SCRIPT_URL =
    "https://script.google.com/macros/s/AKfycbzzCx-aBFZRPS8LDLll2GZcd-DOcwfPeGTB_kDGn9fVAbwjm5ZBgEjKaIB3G5WTMGcd/exec";

  const [form, setForm] = useState({
    tipo: "",

    nombre: "",
    apellido: "",

    celular: "",
    tipo_celular: "",

    documento: "",

    pais: "",
    departamento: "",

    iglesia: "",

    edad: "",

    proyecto: "",

    estadoCivil: "",
    hijos: "",

    especialidad: "",
    comentario: "",

    especialidades: [],
  });

  // ==========================
  // ACTUALIZAR INPUTS
  // ==========================

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });

    setMensajeError("");
  };

  // ==========================
  // CHECKBOX
  // ==========================

  const handleCheckbox = (e) => {
    const { value, checked } = e.target;

    if (checked) {
      setForm({
        ...form,
        especialidades: [...form.especialidades, value],
      });
    } else {
      setForm({
        ...form,
        especialidades: form.especialidades.filter((item) => item !== value),
      });
    }
  };

  // ==========================
  // VALIDACIÓN
  // ==========================
  const validarFormulario = () => {
    if (!tipo) {
      setMensajeError("Seleccione un tipo de participante.");
      return false;
    }

    let camposObligatorios = [];

    //==============================
    // CAMPISTA
    //==============================

    if (tipo === "campista") {
      camposObligatorios = [
        "nombre",
        "apellido",
        "celular",
        "tipo_celular",
        "documento",
        "pais",
        "departamento",
        "iglesia",
        "edad",
        "proyecto",
      ];
    }

    //==============================
    // LIDER
    //==============================

    if (tipo === "lider") {
      camposObligatorios = [
        "nombre",
        "apellido",
        "celular",
        "documento",
        "pais",
        "departamento",
        "iglesia",
        "edad",
        "estadoCivil",
        "hijos",
      ];
    }

    //==============================
    // VOLUNTARIO
    //==============================

    if (tipo === "voluntario") {
      camposObligatorios = [
        "nombre",
        "apellido",
        "celular",
        "iglesia",
        "especialidad",
      ];
    }

    for (const campo of camposObligatorios) {
      if (!form[campo] || form[campo].toString().trim() === "") {
        setMensajeError("Debe completar todos los campos obligatorios.");

        return false;
      }
    }

    // celular

    if (!/^[0-9]{9,15}$/.test(form.celular)) {
      setMensajeError("Ingrese un número de celular válido.");

      return false;
    }

    // edad solo para campista y líder

    if (tipo !== "voluntario") {
      if (Number(form.edad) < 13 || Number(form.edad) > 99) {
        setMensajeError("Ingrese una edad válida.");

        return false;
      }
    }

    setMensajeError("");

    return true;
  };

  // ==========================
  // ENVIAR FORMULARIO
  // ==========================

  const enviarFormulario = async (e) => {
    e.preventDefault();

    // ==========================
    // VALIDAR FORMULARIO
    // ==========================

    if (!validarFormulario()) {
      return;
    }

    setLoading(true);

    try {
      // ==========================
      // ENVIAR REGISTRO
      // ==========================

      await fetch(GOOGLE_SCRIPT_URL, {
        method: "POST",
        mode: "no-cors",
        headers: {
          "Content-Type": "text/plain",
        },
        body: JSON.stringify({
          accion: "registro",
          ...form,
          tipo,
        }),
      });

      // ==================================================
      // CAMPISTA
      // REGISTRO → PAGO
      // ==================================================

      if (tipo === "campista") {
        // Guardar datos necesarios para el pago

        setDatosPago({
          nombre: `${form.nombre} ${form.apellido}`,
          documento: form.documento,
        });

        // ==========================
        // CERRAR MODAL REGISTRO
        // ==========================

        const modalElement = document.getElementById("registroModal");

        const modalInstance = bootstrap.Modal.getInstance(modalElement);

        if (modalInstance) {
          modalInstance.hide();
        }

        // ==========================
        // LIMPIAR BACKDROP
        // ==========================

        setTimeout(() => {
          document.body.classList.remove("modal-open");

          document.body.style.removeProperty("overflow");

          document.body.style.removeProperty("padding-right");

          document
            .querySelectorAll(".modal-backdrop")
            .forEach((el) => el.remove());

          // ==========================
          // ABRIR MODAL DE PAGO
          // ==========================

          setMostrarPago(true);
        }, 300);
      } else {
        // ==================================================
        // LÍDER / VOLUNTARIO
        // REGISTRO → MENSAJE → RECARGA
        // ==================================================

        // Cerrar modal de registro

        const modalElement = document.getElementById("registroModal");

        const modalInstance = bootstrap.Modal.getInstance(modalElement);

        if (modalInstance) {
          modalInstance.hide();
        }

        // ==========================
        // LIMPIAR BACKDROP
        // ==========================

        setTimeout(() => {
          document.body.classList.remove("modal-open");

          document.body.style.removeProperty("overflow");

          document.body.style.removeProperty("padding-right");

          document
            .querySelectorAll(".modal-backdrop")
            .forEach((el) => el.remove());
        }, 300);

        // ==========================
        // MENSAJE DE ÉXITO
        // ==========================

        await Swal.fire({
          icon: "success",
          title: "¡Registro exitoso!",
          text: "Tus datos fueron enviados correctamente.",
          confirmButtonText: "Continuar",
          confirmButtonColor: "#9b2a92",
          background: "#ffffff",
          color: "#333",
        });

        // ==========================
        // RECARGAR PÁGINA
        // ==========================

        window.location.reload();
      }

      // ==========================
      // LIMPIAR FORMULARIO
      // ==========================

      setForm({
        tipo: "",

        nombre: "",
        apellido: "",

        celular: "",
        tipo_celular: "",

        documento: "",

        pais: "",
        departamento: "",

        iglesia: "",

        edad: "",

        proyecto: "",

        estadoCivil: "",
        hijos: "",

        especialidad: "",
        comentario: "",

        especialidades: [],
      });

      setTipo("");

      setMensajeError("");
    } catch (error) {
      console.error("Error al enviar el formulario:", error);

      // ==========================
      // ERROR
      // ==========================

      Swal.fire({
        icon: "error",
        title: "Ups...",
        text: "No fue posible enviar el formulario.",
        confirmButtonColor: "#9b2a92",
      });
    } finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
    const modalElement = document.getElementById("registroModal");

    if (!modalElement) return;

    const modalInstance =
      bootstrap.Modal.getOrCreateInstance(modalElement);

    if (show) {
      modalInstance.show();
    } else {
      modalInstance.hide();
    }
  }, [show]);


  return (
    <>
      <div className="modal fade" id="registroModal" tabIndex="-1">
        <div className="modal-dialog modal-fullscreen-md-down modal-xl modal-dialog-centered modal-dialog-scrollable">
          <div
            className="modal-content border-0 shadow-lg"
            style={{
              borderRadius: "25px",
              overflow: "hidden",
            }}
          >
            {/* ================= HEADER ================= */}

            <div
              className="text-white p-4"
              style={{
                background:
                  "linear-gradient(135deg,#44296a 0%,#370a33 100%,#0f5513 100%)",
              }}
            >
              <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">
                <div>
                  <h3 className="fw-bold mb-1">¡PARTICIPA!</h3>

                  <p className="mb-0 opacity-75">
                    Queremos hablar contigo, conocerte y ayudarte en los pasos
                    para tu Pre-Inscripción.
                  </p>
                </div>

                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={onClose}
                  data-bs-dismiss="modal"
                ></button>
              </div>
            </div>

            {/* ================= BODY ================= */}

            <div
              className="modal-body"
              style={{
                padding: "clamp(1rem,3vw,2rem)",
              }}
            >
              {/* SELECTOR */}

              <div className="selector-inscripcion d-flex justify-content-center gap-4 mb-5 flex-wrap">
                <div
                  className={`selector-card ${tipo === "campista" ? "selector-card-active" : ""
                    }`}
                  onClick={() => {
                    setTipo("campista");
                    setMensajeError("");
                  }}
                >
                  <img src={campista} alt="Campista" className="selector-img" />

                  <span className="selector-texto">MIEMBROS</span>
                </div>

                <div
                  className={`selector-card ${tipo === "lider" ? "selector-card-active" : ""
                    }`}
                  onClick={() => {
                    setTipo("lider");
                    setMensajeError("");
                  }}
                >
                  <img src={lider} alt="Líder" className="selector-img" />

                  <span className="selector-texto">LÍDERES</span>
                </div>

                <div
                  className={`selector-card ${tipo === "voluntario" ? "selector-card-active" : ""
                    }`}
                  onClick={() => {
                    setTipo("voluntario");
                    setMensajeError("");
                  }}
                >
                  <img
                    src={voluntario}
                    alt="Voluntario"
                    className="selector-img"
                  />

                  <span className="selector-texto">VOLUNTARIOS</span>
                </div>
              </div>

              {/* FORMULARIO */}

              <form onSubmit={enviarFormulario}>
                {tipo === "campista" && (
                  <FormCampista form={form} handleChange={handleChange} />
                )}

                {tipo === "lider" && (
                  <FormLider form={form} handleChange={handleChange} />
                )}

                {tipo === "voluntario" && (
                  <FormVoluntario
                    form={form}
                    handleChange={handleChange}
                    handleCheckbox={handleCheckbox}
                  />
                )}

                {/* ALERTA */}

                {mensajeError && (
                  <div className="alert alert-danger rounded-4 text-center fw-semibold">
                    {mensajeError}
                  </div>
                )}

                {tipo && (
                  <div className="d-flex flex-column flex-md-row justify-content-center align-items-center gap-3 mt-5">
                    <button
                      type="submit"
                      disabled={loading}
                      className="btn text-white rounded-pill px-5 py-3"
                      style={{
                        background: "linear-gradient(135deg,#9b2a92,#3d1042)",
                        border: "none",
                        minWidth: "240px",
                      }}
                    >
                      {loading ? "Enviando..." : "Guardar Registro"}
                    </button>
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
      <ModalPago
        show={mostrarPago}
        datos={datosPago}
        onClose={() => {
          setMostrarPago(false);
        }}
        onPagoRegistrado={() => {
          // Cerrar ModalPago
          setMostrarPago(false);

          // Abrir ModalConfirmacionPago
          setTimeout(() => {
            setMostrarConfirmacion(true);
          }, 400);
        }}
      />
      <ModalConfirmacionPago
        show={mostrarConfirmacion}
        onClose={() => {
          setMostrarConfirmacion(false);

          setTimeout(() => {
            window.location.reload();
          }, 300);
        }}
      />
    </>
  );
};
